<template>
  <v-row>
    <v-col cols="12">
      <div>
        <v-simple-table dense class="ma-1 pa-1">
          <template v-slot:default>
            <tbody>
              <tr>
                <th scope="col" class="caption font-weight-bold ma-1 ml-8 pa-1">Base de Dados</th>
                <th scope="col" class="caption font-weight-bold ma-1 pa-1">Linhas</th>
                <th scope="col" class="caption font-weight-bold ma-1 pa-1">Atualização mais Recente</th>
              </tr>
              <tr title="Razão">
                <td class="caption font-weight-regular ma-1 ml-8 pa-1">Razão</td>
                <td class="caption font-weight-regular ma-1 pa-1">
                  <v-progress-circular
                    v-if="carregando"
                    indeterminate
                    :color="progress.color"
                    :size="progress.size"
                    :width="progress.width"
                  />
                  <span v-else>{{ Razao }}</span>
                </td>
                <td class="caption font-weight-regular ma-1 pa-1">
                  <v-progress-circular
                    v-if="carregando"
                    indeterminate
                    :color="progress.color"
                    :size="progress.size"
                    :width="progress.width"
                  />
                  <span v-else>
                    {{ Data_Lancamento_Razao }}
                  </span>
                </td>
              </tr>
              <tr title="AIS">
                <td class="caption font-weight-regular ma-1 pa-1">AIS</td>
                <td class="caption font-weight-regular ma-1 pa-1">
                  <v-progress-circular
                    v-if="carregando"
                    indeterminate
                    :color="progress.color"
                    :size="progress.size"
                    :width="progress.width"
                  />
                  <span v-else>
                    {{ AIS }}
                  </span>
                </td>
                <td class="caption font-weight-regular ma-1 pa-1">
                  <v-progress-circular
                    v-if="carregando"
                    indeterminate
                    :color="progress.color"
                    :size="progress.size"
                    :width="progress.width"
                  />
                  <span v-else>
                    {{ Max_Data_Base_AIS }}
                  </span>
                </td>
              </tr>
              <tr title="BDGD">
                <td class="caption font-weight-regular ma-1 pa-1">BDGD</td>
                <td class="caption font-weight-regular ma-1 pa-1">
                  <v-progress-circular
                    v-if="carregando"
                    indeterminate
                    :color="progress.color"
                    :size="progress.size"
                    :width="progress.width"
                  />
                  <span v-else>{{ BDGD }}</span>
                </td>
                <td class="caption font-weight-regular ma-1 pa-1">
                  <v-progress-circular
                    v-if="carregando"
                    indeterminate
                    :color="progress.color"
                    :size="progress.size"
                    :width="progress.width"
                  />
                  <span v-else>{{ Max_Data_Base_BDGD }} - Versão: {{ Ultima_Versao_BDGD }}</span>
                </td>
              </tr>
              <tr title="Base blindada">
                <td class="caption font-weight-regular ma-1 pa-1">Base blindada</td>
                <td class="caption font-weight-regular ma-1 pa-1">
                  <v-progress-circular
                    v-if="carregando"
                    indeterminate
                    :color="progress.color"
                    :size="progress.size"
                    :width="progress.width"
                  />
                  <span v-else>{{ Blindado }}</span>
                </td>
                <td></td>
              </tr>
              <tr title="Laudo incremental">
                <td class="caption font-weight-regular ma-1 pa-1">Laudo incremental</td>
                <td class="caption font-weight-regular ma-1 pa-1">
                  <v-progress-circular
                    v-if="carregando"
                    indeterminate
                    :color="progress.color"
                    :size="progress.size"
                    :width="progress.width"
                  />
                  <span v-else>
                    {{ Laudo }}
                  </span>
                </td>
                <td></td>
              </tr>
              <tr title="Sped ICMS Bloco C">
                <td class="caption font-weight-regular ma-1 pa-1">Sped ICMS Bloco C</td>
                <td class="caption font-weight-regular ma-1 pa-1">
                  <v-progress-circular
                    v-if="carregando"
                    indeterminate
                    :color="progress.color"
                    :size="progress.size"
                    :width="progress.width"
                  />
                  <span v-else>
                    {{ Sped_ICMS_Bloco_C }}
                  </span>
                </td>
                <td></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-col>
  </v-row>
</template>

<script>
  import GraficosService from '../../../services/GraficosService';

  export default {
    data() {
      return {
        carregando: true,
        resumo: {
          ais: 0,
          Razao: 0,
          bdgd: 0,
          blindado: 0,
          laudo_incremental: 0,
          sped_icms_bloco_c: 0,
          data_lancamento_razao: '',
          max_data_base_ais: '',
          max_data_base_bdgd: '',
          ultima_versao_bdgd: ''
        },
        progress: {
          color: 'black',
          size: 20,
          width: 1
        }
      };
    },
    computed: {
      empresa() {
        return this.$store.getters.getEmpresa;
      },
      AIS() {
        return this.resumo.ais;
      },
      Razao() {
        return this.resumo.razao;
      },
      BDGD() {
        return this.resumo.bdgd;
      },
      Blindado() {
        return this.resumo.blindado;
      },
      Laudo() {
        return this.resumo.laudo_incremental;
      },
      Sped_ICMS_Bloco_C() {
        return this.resumo.sped_icms_bloco_c;
      },
      Data_Lancamento_Razao() {
        return this.resumo.data_lancamento_razao;
      },
      Max_Data_Base_AIS() {
        return this.resumo.max_data_base_ais;
      },
      Max_Data_Base_BDGD() {
        return this.resumo.max_data_base_bdgd;
      },
      Ultima_Versao_BDGD() {
        return this.resumo.ultima_versao_bdgd;
      }
    },
    mounted() {
      this.getResumo();
    },
    methods: {
      getResumo() {
        GraficosService.getDadosByNome('Resumo das Bases Importadas')
          .then(({ data }) => {
            const mapResumo = {
              AIS: 'ais',
              Razao: 'razao',
              BDGD: 'bdgd',
              Blindado: 'blindado',
              'Laudo incremental': 'laudo_incremental',
              'Sped ICMS Bloco C': 'sped_icms_bloco_c',
              DataLancamentoRazao: 'data_lancamento_razao',
              MaxDataBaseAIS: 'max_data_base_ais',
              MaxDataBaseBDGD: 'max_data_base_bdgd',
              UltimaVersaoBDGDNoMesCoincidenteAISxBDGD: 'ultima_versao_bdgd'
            };

            if (data && data.data) {
              data.data.forEach((item) => {
                const key = mapResumo[item.origem];
                if (key) {
                  const valor = Number(item.valor);
                  if (isNaN(valor)) {
                    let date = new Date(item.valor);
                    this.resumo[key] = new Intl.DateTimeFormat('pt-BR').format(date);
                  } else {
                    this.resumo[key] = new Intl.NumberFormat('pt-BR').format(valor);
                  }
                }
              });
            }
          })
          .finally(() => (this.carregando = false));
      }
    }
  };
</script>
